// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import $ from 'jquery';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------
const baseClass = 'etermin-container';
let timer;
// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class eTermin {
  constructor(el) {
    this.el = el;

    this.initResizeScript();
    this.resize();
    this.checkHeight();
  }

  checkHeight() {
    timer = window.setInterval(function() {
      if ($(window).width() > 1064) {
        const iFrameHeight = $(`.${baseClass}`).find('iframe');

        if (iFrameHeight.height() > 445 && iFrameHeight.height() != 1600) {
          $(`.${baseClass}`).css('height', 'auto');
          window.clearTimeout(timer);
        }
      }
    },250);
  }

  initResizeScript() {
    setTimeout(function (){
      $('body').append('<script src="https://www.eTermin.net/js/resizecustomersitescroll.min.js" type="text/javascript"></script>');

      if ($(window).width() > 1064) {
        $(`.${baseClass}`).css('height', '444px');
      }
    },500);
  }

  resize() {
    $(window).resize(function () {
      if ($(window).width() < 1065) {
        $(`.${baseClass}`).css('height', 'auto');
      } else {

        timer = window.setInterval(function() {
          if ($(window).width() > 1064) {
            const iFrameHeight = $(`.${baseClass}`).find('iframe');

            if (iFrameHeight.height() > 445 && iFrameHeight.height() != 1600) {
              $(`.${baseClass}`).css('height', 'auto');
              window.clearTimeout(timer);
            } else {
              $(`.${baseClass}`).css('height', '444px');
            }
          }
        },250);
      }
    });
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new eTermin(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
